import api from "./api";

export interface FolhaLancamentoDto {
  id: string;
  quinzena: string;
  funcao: string;
  colaborador: string;
  casa: string;
  servicoId: number | null;
  servicoNome: string;
  valorPagamento: number;
  valorDoServico: number;
  saldo: number;
  createdAt: string;
  updatedAt: string;
}

export interface FolhaLancamentoFormValues {
  quinzena: string;
  funcao: string;
  colaborador: string;
  casa: string;
  servicoId?: number | null;
  servicoNome: string;
  valorPagamento: number;
  valorDoServico: number;
}

const BASE_URL = "/api/folha-pagamentos/lancamentos";

export async function listFolhaLancamentos(): Promise<FolhaLancamentoDto[]> {
  const { data } = await api.get<{ success: boolean; lancamentos: FolhaLancamentoDto[] }>(BASE_URL);
  return data.lancamentos;
}

export async function createFolhaLancamento(
  values: FolhaLancamentoFormValues,
): Promise<FolhaLancamentoDto> {
  const { data } = await api.post<{ success: boolean; lancamento: FolhaLancamentoDto }>(
    BASE_URL,
    values,
  );
  return data.lancamento;
}

export async function updateFolhaLancamento(
  id: string,
  values: FolhaLancamentoFormValues,
): Promise<FolhaLancamentoDto> {
  const { data } = await api.patch<{ success: boolean; lancamento: FolhaLancamentoDto }>(
    `${BASE_URL}/${encodeURIComponent(id)}`,
    values,
  );
  return data.lancamento;
}

export async function deleteFolhaLancamento(id: string): Promise<void> {
  await api.delete(`${BASE_URL}/${encodeURIComponent(id)}`);
}
